import type { ActionAuditEvent, ActionAuditFieldChange } from "@/models/actionAudit";

export function actionAuditFieldName(change: ActionAuditFieldChange): string {
  return change.displayLabel?.trim() || lastPathComponent(change.key);
}

export function relativeActionAuditTime(date: Date, now = new Date()): string {
  const deltaSeconds = Math.round((date.getTime() - now.getTime()) / 1_000);
  const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  const absoluteSeconds = Math.abs(deltaSeconds);

  if (absoluteSeconds < 60) return formatter.format(deltaSeconds, "second");
  const minutes = Math.round(deltaSeconds / 60);
  if (Math.abs(minutes) < 60) return formatter.format(minutes, "minute");
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return formatter.format(hours, "hour");
  return formatter.format(Math.round(hours / 24), "day");
}

export function actionAuditCollectionDisplayName(collection: string): string {
  switch (collection) {
    case "leagues":
      return "League settings";
    case "organizations":
      return "Organization profile";
    case "leagueAthleteValues":
      return "Athlete record";
    case "leagueAthleteSchemas":
      return "Athlete fields";
    case "leagueOrganizationAdminSchemas":
      return "Organization admin fields";
    case "leagueOrganizationAdminValues":
      return "Organization admin profile";
    case "leagueCompetitionTemplates":
      return "Competition type";
    case "leagueCompetitionInstances":
      return "Competition";
    default:
      return collection;
  }
}

export function actionAuditActionLabel(action: ActionAuditEvent["actionType"]): string {
  switch (action) {
    case "create":
      return "Created";
    case "update":
      return "Updated";
    case "archive":
      return "Archived";
    case "undo":
      return "Undid";
  }
}

function lastPathComponent(key: string): string {
  return key.split(".").at(-1) || key;
}
